module.exports = __webpack_public_path__ + "static/media/box.a11c0c95.svg";